import React from 'react';
import Chunk from 'components/Chunk';

const loadOrdersContainer = () => import('./containers' /* webpackChunkName: "orders" */ /* webpackPreload: true */);

const Orders = () => <Chunk load={loadOrdersContainer} />;

export default Orders;
